import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Proof } from '@feature/proof';
import { generateProofApi, generateProofOptions } from '@feature/proof/proofGenerator';
import { Id } from '@feature/utils';

const proceedingProofApi = generateProofApi('/proof-file/proceeding');
const { getProofsOptions, getProofsByOwnerOptions, createOrUpdateProofOptions, deleteProofOptions } =
  generateProofOptions('proceeding', proceedingProofApi);

export function getProceedingProofsByOwnerOptions(proceedingId: Id, userId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsByOwnerOptions(proceedingId, userId);
}

export function getProceedingProofsOptions(proceedingId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsOptions(proceedingId);
}

export function useUploadOrUpdateProceedingProof(proceedingId: Id) {
  const queryClient = useQueryClient();
  return useMutation(createOrUpdateProofOptions(proceedingId, queryClient));
}

export function useDeleteProceedingProof(proceedingId: Id) {
  const queryClient = useQueryClient();
  return useMutation(deleteProofOptions(proceedingId, queryClient));
}
